import axios from "axios";

const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://localhost:7195",
  //baseURL: "http://localhost:8080",
  withCredentials: true,
  headers: {
    "Content-type": "application/json"
  }
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

http.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      if (originalRequest.url && originalRequest.url.includes('/api/public/')) {
        return Promise.reject(error);
      }

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(token => {
          originalRequest.headers['Authorization'] = token;
          return http(originalRequest);
        }).catch(err => {
          return Promise.reject(err);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const user = JSON.parse(localStorage.getItem('user'));

      if (!user || !user.token) {
        isRefreshing = false;
        processQueue(new Error('No session'), null);
        localStorage.removeItem('user');
        window.location.href = "/authentication/basic/login";
        return Promise.reject(error);
      }

      try {
        // El refresh token va en la cookie HttpOnly (withCredentials); solo enviamos el access token.
        const response = await http.post("/api/public/login/refresh", {
          accessToken: user.token.replace("Bearer ", "")
        });

        const newUser = { ...user, token: response.data.token };
        delete newUser.refreshToken; // por si quedó uno de una sesión previa a la migración
        localStorage.setItem('user', JSON.stringify(newUser));

        processQueue(null, newUser.token);

        originalRequest.headers['Authorization'] = newUser.token;
        return http(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError, null);
        localStorage.removeItem('user');
        window.location.href = "/authentication/basic/login";
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default http;
